import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { connect } from "react-redux";
import App from "./containers/App/App";
import asyncComponent from "./helpers/AsyncFunc";

const RestrictedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/signin",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
const DashboardRedirect = () => <Redirect to="/dashboard/" />;
const PublicRoutes = ({ history, isLoggedIn }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        {
          isLoggedIn ? (
            <Switch>
              <Route exact path="/" render={() => <DashboardRedirect />} />
                <RestrictedRoute
                  path="/dashboard"
                  component={App}
                  isLoggedIn={isLoggedIn}
                />
                <Route render={() => <DashboardRedirect />} />
            </Switch>
        ):
        (
          <Switch>
            <Route
              exact
              path={"/"}
              component={asyncComponent(() => import("./containers/Page/signin"))}
            />
            <Route
              exact
              path={"/404"}
              component={asyncComponent(() => import("./containers/Page/404"))}
            />
            <Route
              exact
              path={"/500"}
              component={asyncComponent(() => import("./containers/Page/500"))}
            />
            <Route
              exact
              path={"/signin"}
              component={asyncComponent(() => import("./containers/Page/signin"))}
            />
            <Route
              exact
              path={"/forgotpassword"}
              component={asyncComponent(() =>
                import("./containers/Page/forgotPassword")
              )}
            />
          </Switch>    
        )
        }
      </Switch>
    </ConnectedRouter>
  );
};

export default connect(state => {
    return ({
      isLoggedIn: state.Auth && state.Auth.idToken !== null
      })
})(PublicRoutes);
